import Sortable from '@stimulus-components/sortable';
import SortableJS from 'sortablejs';

export default class extends Sortable {
  static values = { group: String, draggable: String, nested: String };

  connect() {
    if (this.sortable) return;

    super.connect();
  }

  // Moving a group re-attaches the card lists inside it; destroying their
  // Sortable here would cut the drag short.
  disconnect() {
    if (this.element.isConnected) return;

    super.disconnect();
  }

  get defaultOptions() {
    return {
      group: this.groupValue || undefined,
      draggable: this.draggableValue || undefined,
      swapThreshold: 0.65,
      forceFallback: true,
      fallbackOnBody: true,
      fallbackTolerance: 3,
      ghostClass: 'opacity-40',
      onSort: () => this.dispatch('update'),
      onStart: () => this.pauseNested(true),
      onEnd: () => this.pauseNested(false),
    };
  }

  pauseNested(paused) {
    if (!this.nestedValue) return;

    this.element.querySelectorAll(this.nestedValue).forEach((list) => SortableJS.get(list)?.option('disabled', paused));
  }
}
